/* eslint-disable react/react-in-jsx-scope */
import clsx from 'clsx'
const CustomRow = ({row, paddless}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell, i) => {
      return (
        <td
          key={i}
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions', 'p-0': paddless})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
